// extracted by mini-css-extract-plugin
export var component = "Invoice-module--component--hgLKA";
export var title = "Invoice-module--title--AdGLo";
export var status = "Invoice-module--status--uO7RG";
export var status0 = "Invoice-module--status0--Kc9ms";
export var status1 = "Invoice-module--status1--xFnfb";
export var status2 = "Invoice-module--status2--91ptd";
export var list = "Invoice-module--list--DuJS+";
export var content = "Invoice-module--content--zc+7c";
export var label = "Invoice-module--label--tqYnE";
export var value = "Invoice-module--value--up+YI";
export var link = "Invoice-module--link--ZiPKK";